module.exports = __webpack_public_path__ + "static/media/playbutton.4045bf66.svg";